import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const FeaturedCreationsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-pink-50/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            ✨ Nos créations signature ✨
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez nos dernières créations, spécialement conçues pour vos moments précieux
          </p>
        </div>

        {/* Featured Creations Grid */}
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Bento Cake Feature */}
          <Card className="overflow-hidden shadow-elegant border-pink-100 hover:shadow-glow transition-smooth">
            <div className="relative h-80 overflow-hidden bg-gradient-to-br from-pink-50 to-rose-50">
              <img
                src="/images/bento-hero.jpg"
                alt="Bento Cake élégant avec cupcakes assortis"
                className="w-full h-full object-cover hover:scale-105 transition-smooth"
              />
              <div className="absolute inset-0 bg-pink-500/10"></div>
            </div>
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                🍱 Bento Cakes Signature
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Découvrez nos élégants Bento Cakes — parfaits pour vos petits plaisirs sucrés 
                et vos occasions spéciales. Chaque création est unique et personnalisée selon vos envies.
              </p>
              <div className="flex items-center justify-between mb-6">
                <div className="text-2xl font-bold text-primary">À partir de 20€</div>
                <div className="text-sm text-gray-500 bg-pink-50 px-3 py-1 rounded-full">
                  6 parts + cupcakes
                </div>
              </div>
              <Button 
                className="w-full gradient-primary text-white shadow-elegant"
                onClick={() => {
                  const element = document.querySelector("#contact");
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                Commander votre Bento Cake
              </Button>
            </CardContent>
          </Card>

          {/* Cupcakes Feature */}
          <Card className="overflow-hidden shadow-elegant border-pink-100 hover:shadow-glow transition-smooth">
            <div className="relative h-80 overflow-hidden bg-gradient-to-br from-yellow-50 to-orange-50">
              <img
                src="/images/cupcakes-hero.jpg"
                alt="Cupcakes raffinés au glaçage soyeux"
                className="w-full h-full object-cover hover:scale-105 transition-smooth"
              />
              <div className="absolute inset-0 bg-pink-500/10"></div>
            </div>
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                🧁 Cupcakes Raffinés
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Des cupcakes raffinés, au glaçage soyeux et aux saveurs uniques. 
                Parfaits pour vos événements, avec des décorations élégantes et personnalisées.
              </p>
              <div className="flex items-center justify-between mb-6">
                <div className="text-2xl font-bold text-primary">Boîte de 4 à partir de 6€</div>
                <div className="text-sm text-gray-500 bg-pink-50 px-3 py-1 rounded-full">
                  Minimum 4 pièces
                </div>
              </div>
              <Button 
                className="w-full gradient-primary text-white shadow-elegant"
                onClick={() => {
                  const element = document.querySelector("#contact");
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                Commander vos Cupcakes
              </Button>
            </CardContent>
          </Card>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-elegant border border-pink-100 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              🎨 Créations 100% personnalisées
            </h3>
            <p className="text-gray-600 mb-6">
              Chaque gâteau et cupcake peut être adapté selon vos goûts, couleurs préférées 
              et thème de votre événement. Contactez Gemima pour discuter de votre projet !
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                className="gradient-primary text-white shadow-elegant"
                onClick={() => window.open("https://wa.me/33753797698", "_blank")}
              >
                💬 WhatsApp direct
              </Button>
              <Button
                variant="outline"
                className="border-2 border-primary text-primary hover:bg-primary hover:text-white"
                onClick={() => window.open("https://www.instagram.com/sweetsby_gem", "_blank")}
              >
                📸 Voir plus sur Instagram
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCreationsSection;